// Re-export from primitives/icons for backward compatibility
export * from '@/primitives/icons';
